/**
 * FlowHelp — ein ⓘ-Info-Icon mit deutschem Erklär-Popover für den Flows-Editor.
 *
 * Dünner Wrapper um die geteilte <InfoButton>-Komponente: schlägt den Text zum
 * `k`(ey) in flowFieldHelp nach und rendert Titel + Absätze. `q` (Frage/Stichwort)
 * wird fett vorangestellt, `p` ist der Erklärtext.
 *
 * Nutzung:
 *   <FlowHelp k="mapsTo" />                 // an einem Feld/Sektions-Titel
 *   <FlowHelp k="identity" position="right" />
 */
import InfoButton from '../../shared/InfoButton.jsx'
import { FLOW_HELP } from './flowFieldHelp.js'

export function FlowHelp({ k, position = 'bottom' }) {
  const entry = FLOW_HELP[k]
  if (!entry) return null
  return (
    <InfoButton title={entry.title} position={position}>
      {entry.items.map((it, i) => (
        <p key={i} className="flow-help-item">
          {it.q ? <strong>{it.q} </strong> : null}
          {it.p}
        </p>
      ))}
    </InfoButton>
  )
}

export default FlowHelp
